import React from 'react';

import Panel from './panel';

export default class Accordion extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            currentPanel: 1,
        }
    }

    componentDidMount() {
        switch(this.props.route) {
            case 'privatpatient':
                this.setState({
                    currentPanel: 1
                })
                break;
            case 'schwangerschaft':
                this.setState({
                    currentPanel: 2
                })
                break;
            case 'kontrastmittel':
                this.setState({
                    currentPanel: 3
                })
                break;
            case 'stillen':
                this.setState({
                    currentPanel: 4
                })
                break;
            case 'mammographie':
                this.setState({
                    currentPanel: 5
                })
                break;
            case 'ergebnisse':
                this.setState({
                    currentPanel: 6
                })
                break;
            default:
                this.setState({
                    currentPanel: 0
                })
        } 
    }

    updateCurrentPanel(id) {
        this.setState({
            currentPanel: id,
        });
    }

    render() {
        let {children} = this.props;
        let {currentPanel} = this.state;
        return  (
            <div className="container-custom">
                <Panel active={(currentPanel==1?true:false)}>
                    <h3 className="panel--title large" onClick={()=>this.updateCurrentPanel(1)}>
                        Wie erhalte ich einen Termin als Privatpatient?
                    </h3>
                    <div className="panel--content">
                        Privatpatienten erhalten außerhalb der Kassenöffnungszeiten unter der Telefonnummer 0664 4155619 Termine.
                    </div>
                </Panel>
                <Panel active={(currentPanel==2?true:false)}>
                    <h3 className="panel--title large" onClick={()=>this.updateCurrentPanel(2)}>
                        Was gilt es bei einer Schwangerschaft zu beachten?
                    </h3>
                    <div className="panel--content">
                        Schwangere Frauen werden in unserem Institut nicht geröntgt.<br/>
                        MRT-Untersuchungen sind nur nach Rücksprache mit der/dem/ zuweisenden Ärztin/Arzt und des Radiologen ab dem 2. Trimenon möglich.<br/>
                        Ultraschalluntersuchungen können immer durchgeführt werden.
                    </div>
                </Panel>
                <Panel active={(currentPanel==3?true:false)}>
                    <h3 className="panel--title large" onClick={()=>this.updateCurrentPanel(3)}>
                        Was sind Kontrastmittel?
                    </h3>
                    <div className="panel--content">
                        Durch Kontrastmittel können bestimmte Strukturen (Entzündungen, Tumore, Blutgefäße etc.) besser beurteilt werden. Da MR-Kontrastmittel über die Nieren ausgeschieden wird, benötigen wir Ihren aktuellen Nieren-Blutwert (Kreatininwert), bitte bringen Sie diesen zur Untersuchung mit.<br/>
                        Die Fahrtauglichkeit wird nicht beeinträchtigt.
                    </div>
                </Panel>
                <Panel active={(currentPanel==4?true:false)}>
                    <h3 className="panel--title large" onClick={()=>this.updateCurrentPanel(4)}>
                        Was ist, wenn ich stille?
                    </h3>
                    <div className="panel--content">
                        Röntgenstrahlen haben keine Auswirkungen auf das Stillen.<br/>
                        Bitte teilen Sie uns vor einer Kontrastmittelgabe mit, dass Sie stillen.
                    </div>
                </Panel>
                <Panel active={(currentPanel==5?true:false)}>
                    <h3 className="panel--title large" onClick={()=>this.updateCurrentPanel(5)}>
                        In welchen zeitlichen Abständen kann ich eine Mammographie in Anspruch nehmen?
                    </h3>
                    <div className="panel--content">
                        Für eine Vorsorge-Mammographie bei Frauen zwischen 45 und 69 Jahren ist die E-card alle zwei Jahre automatisch freigeschaltet.<br/>
                        Ausführliche Informationen hierzu erhalten sie auf der Internetseite: <a href="http://www.frueh-erkennen.at">www.frueh-erkennen.at</a><br/>
                        Bei Beschwerden können Sie jederzeit mit einer Überweisung einen Termin bei uns vereinbaren.
                    </div>
                </Panel>
                <Panel active={(currentPanel==6?true:false)}>
                    <h3 className="panel--title large" onClick={()=>this.updateCurrentPanel(6)}>
                        Wer teilt mir meine Untersuchungsergebnisse mit?
                    </h3>
                    <div className="panel--content">
                        Die Befundbesprechung erfolgt bei Ihrer/Ihrem überweisenden Ärztin/Arzt.
                    </div>
                </Panel>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/accordion/index.jsx